import { render, staticRenderFns } from "./CheckboxTooltipHint.vue?vue&type=template&id=f3510ca8&scoped=true"
import script from "./CheckboxTooltipHint.vue?vue&type=script&lang=js"
export * from "./CheckboxTooltipHint.vue?vue&type=script&lang=js"
import style0 from "./CheckboxTooltipHint.vue?vue&type=style&index=0&id=f3510ca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3510ca8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VIcon,VTooltip})
